import { Bean } from '@dreryk/react-common';

import { useFormsTemplatesContext } from './formsTemplatesContext';
import { EMPTY_TEMPLATE_ID } from './list/FormsTemplatesListItemsRenderer';

export const withTemplateSaveButton = <PROPS extends Bean>(
   CreateButton: (props: PROPS) => JSX.Element,
   UpdateButton: (props: PROPS) => JSX.Element
): ((props: PROPS) => JSX.Element | null) => {
   const TemplateSaveButton = (props: PROPS): JSX.Element | null => {
      const { activeItem, mode } = useFormsTemplatesContext();

      if (!mode) {
         return null;
      }

      if (activeItem.id === EMPTY_TEMPLATE_ID) {
         return <CreateButton {...props} />;
      }

      return <UpdateButton {...props} />;
   };

   return TemplateSaveButton;
};
